export const FIELD_LABEL_CLASS = 'text-xs font-medium text-[#082729]';

// Same URL the platform already links to.
export const PRIVACY_POLICY_URL = 'https://www.7i7.de/datenschutz';

// The PDFs of the terms only go out with the contract confirmation mail.
export const TERMS_URL = 'https://www.7i7.de/agb';

// Contact for customers whose link no longer works.
export const CONTACT_MAIL = 'info@7i7.de';
